import PropTypes from 'prop-types';

const money = PropTypes.oneOfType([PropTypes.string, PropTypes.number]);

const surchargesShape = PropTypes.arrayOf(
  PropTypes.shape({
    name: PropTypes.string,
    amount: money,
  }),
);

export const seriesPassProductShape = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  price: money.isRequired,
  calculatedPrice: money,
  maxPerOrder: PropTypes.number,
  allInPriceDescription: PropTypes.string,
  upcomingPrice: PropTypes.shape({
    price: money.isRequired,
    calculatedPrice: money,
    startsAt: PropTypes.string.isRequired,
  }),
  priceBreakdownsByQuantity: PropTypes.objectOf(
    PropTypes.shape({
      subtotal: money,
      discount: money,
      fees: money,
      taxes: money,
      total: money,
      surcharges: surchargesShape,
    }),
  ),
  priceBreakdown: PropTypes.shape({
    subtotal: money,
    discount: money,
    fees: money,
    taxes: money,
    total: money,
    surcharges: surchargesShape,
  }),
  checkoutQuestions: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      value: PropTypes.string,
      custom_field: PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        required: PropTypes.bool,
        position: PropTypes.number,
        custom_field_options: PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string.isRequired,
          }),
        ),
      }).isRequired,
    }),
  ),
});
